{
  "lastUpdatedAt": "2026-10-05T08:26:52.490Z",
  "lastFetchAttemptAt": "2026-10-05T08:26:52.490Z",
  "organization": {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "PETPROTECT",
    "alternateName": "PETPROTECT Deutschland",
    "url": "https://www.petprotect.de/",
    "logo": "https://a.storyblok.com/f/288340637667316/300x48/24866b23f2/petprotect_logo.svg",
    "description": "PETPROTECT ist eine führende Tierversicherungs-Vermittlung in Deutschland in Kooperation mit der BarmeniaGothaer.",
    "foundingDate": "2018",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+49 202 4383825",
      "email": "petprotect@barmenia.de",
      "contactType": "Kundenservice",
      "areaServed": "DE",
      "availableLanguage": "German"
    },
    "parentOrganization": {
      "@type": "Organization",
      "name": "Innovares Services GmbH"
    },
    "brand": {
      "@type": "Brand",
      "name": "PETPROTECT"
    },
    "sameAs": [
      "https://www.instagram.com/petprotect.de",
      " https://www.facebook.com/PETPROTECT.Versicherung",
      "https://de.trustpilot.com/review/petprotect.de",
      "https://www.ekomi.de/bewertungen-petprotect.html"
    ]
  },
  "parseError": null,
  "fetchError": null
}